import { useState } from "react";
import { HStack, VStack } from "@chakra-ui/react";
import { useVoteUser } from "src/api/client/vote-user.api";
import { WfHeading } from "src/components/base/wf-heading";
import { IVotingDetailData } from "src/components/common/voting/types";
import { useVotingStatus } from "src/components/common/voting/use-voting-status";
import { VotingAnswersBlock } from "src/components/common/voting/voting-answers-block";
import { VotingRemainingDays } from "src/components/common/voting/voting-remaining-days";
import { nullifyTopTraderProps } from "src/components/feed-card/content-blocks/voting/nullify-top-trader-props";
import { getGlobals } from "src/consts/globals";

export const FeedCardVoting = ({ voteTemplateId, votingUntilDate, currentDate, question, answers, result: initialResult }: IVotingDetailData) => {
    const resultWithoutTopTraders = nullifyTopTraderProps(initialResult);
    const [result, setResult] = useState(resultWithoutTopTraders);
    const voteUserMutation = useVoteUser();
    const { currentPageNodeId } = getGlobals();

    const onVoteChange = (userChoice: number) => {
        voteUserMutation(
            { voteTemplateId, value: userChoice, placement: currentPageNodeId },
            {
                onSuccess: result => {
                    const resultWithoutTopTraders = nullifyTopTraderProps(result);
                    setResult(resultWithoutTopTraders);
                },
            }
        );
    };

    const { hasEnded } = useVotingStatus(votingUntilDate, currentDate);

    return (
        <HStack spacing={4}>
            <VStack align="left" spacing={[1, 2]} minW="100%">
                <WfHeading as="h3" fontSize="md">
                    {question}
                </WfHeading>

                <HStack pb={[1]}>
                    <VotingRemainingDays votingUntilDate={votingUntilDate} currentDate={currentDate} />
                </HStack>

                <VotingAnswersBlock
                    answers={answers}
                    selectedAnswerIndex={result?.userChoice?.[0] ?? null}
                    voteSummary={result?.voteSummary ?? null}
                    hasVotingEnded={hasEnded}
                    onVoteChange={onVoteChange}
                />
            </VStack>
        </HStack>
    );
};
